import script from "./CommentWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommentWidget.vue?vue&type=script&lang=ts&setup=true"

import "./CommentWidget.vue?vue&type=style&index=0&id=85005310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85005310"]])

export default __exports__